import { TranslatePipe } from '../../filters/translate.pipe';
import { InputSwitchComponent } from '../../components/input-switch/input-switch.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import InstantBookingService from '../../services/instant-booking.service';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'item-booking-status-switch',
	templateUrl: './item-booking-status-switch.component.html',
	imports: [ CommonModule, TranslatePipe, InputSwitchComponent, FormsModule ]
})
export class ItemBookingStatusSwitchComponent implements OnInit, OnDestroy {
	private instantBookingService: InstantBookingService = inject(InstantBookingService);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isAllowed = this.instantBookingService.isAllowed();
		
		// this.angularStateHelperService.scopeWF(this, this.instantBookingService.isAvailable, 
		// (isActive) => { this.updateSwitchStatus(isActive); });
		var isAvailableLocal = undefined;
		this.vm.isAvailableChecker = this.angularHelperService.createInterval(() => {
			var newStatus = this.instantBookingService.isAvailable();
			if (isAvailableLocal !== newStatus) {
				this.updateSwitchStatus(newStatus);
			}
		}, 200);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Session.UPDATE,
				() => {
					this.vm.isAllowed = this.instantBookingService.isAllowed();
				})
		);
		
		this.vm.toggleStatus = this.toggleStatus;
	}
	
	ngOnDestroy() {
		if (this.vm.isAvailableChecker) {
			this.angularHelperService.cancelInterval(this.vm.isAvailableChecker);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	updateSwitchStatus(isActive: boolean) {
		this.vm.isActive = isActive;
		this.angularHelperService.createTimer(() => { this.vm.isVisible = this.instantBookingService.isAllowed(); });
	}
	
	toggleStatus = (): void => {
		this.instantBookingService.toggleAvailabilityStatus(!this.vm.isActive);
	}
	
}